import React from 'react';
import { ThreadsSocialCircle } from 'components/SocialCircle';
import SocialButton, { SocialButtonProps } from './SocialButton';

export interface ThreadsButtonProps
  extends Pick<
    SocialButtonProps,
    'disabled' | 'onClick' | 'params' | 'size' | 'tooltip'
  > {}

const ThreadsButton: React.FC<ThreadsButtonProps> = ({
  disabled,
  onClick,
  size,
  tooltip,
}) => (
  <SocialButton
    icon={<ThreadsSocialCircle />}
    label="Threads"
    {...{ disabled, onClick, size, tooltip }}
  />
);

export default ThreadsButton;
